import React from "react";
import MyInquiryDetails from "./MyInquiryDetails";

const MyInquiryBody = () => {
    return (
        <div className="view-qualities folded router-view-container">
            <MyInquiryDetails />
        </div>

    )
}
export default MyInquiryBody;